import { render, staticRenderFns } from "./PrivatePolicy.vue?vue&type=template&id=280c401d"
import script from "./PrivatePolicy.vue?vue&type=script&lang=js"
export * from "./PrivatePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports